import { render, staticRenderFns } from "./AdminStatusTag.vue?vue&type=template&id=b9ed554c&"
import script from "./AdminStatusTag.vue?vue&type=script&lang=ts&"
export * from "./AdminStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports